<template>
  <div>
    <slotModal
      :id-modal="'nomorWhatsApp'"
      :modal-title="'Nomor WhatsApp'"
      v-model="dialog"
      @close="close"
    >
      <template v-slot:modal-content>
        <div class="p-x-20">
          <p class="f-Overpass f-14 f-w-400 m-0 p-t-10 p-b-10">
            Mohon maaf, untuk sementara nomor WhatsApp belum dapat dirubah. Jika
            nomor anda berubah, silahkan daftar kembali menggunakan nomor baru.
          </p>
          <div class="p-t-20 p-b-20">
            <button class="btn btn-primary f-Overpass w-100" @click="close">
              Oke
            </button>
          </div>
        </div>
      </template>
    </slotModal>
  </div>
</template>

<script>
import slotModal from "@/components/slots/slotModal.vue";

export default {
  name: "nomorWhatsApp",
  components: {
    slotModal,
  },

  data() {
    return {
      dialog: false,
    };
  },

  methods: {
    open() {
      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },
  },
};
</script>
